export default __webpack_public_path__ + "static/media/story_other-2.0cc9a94e.png";